"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const autobind_decorator_1 = require("autobind-decorator");
const React = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const TitleComponent_1 = require("./TitleComponent");
let CheckboxComponent = class CheckboxComponent extends React.Component {
    constructor() {
        super(...arguments);
        this.handleCheckbox = () => {
            const newValue = (this.props.currentModel !== true);
            this.props.modelChanged(this.props.field, newValue);
        };
    }
    render() {
        return React.createElement("div", null,
            React.createElement("div", null,
                React.createElement(TitleComponent_1.TitleComponent, { field: this.props.field }),
                React.createElement("br", null)),
            React.createElement(react_bootstrap_1.Checkbox, { bsClass: "custom-checkbox", disabled: this.props.readonly, onChange: this.handleCheckbox, checked: this.props.currentModel === true }));
    }
};
CheckboxComponent = __decorate([
    autobind_decorator_1.default
], CheckboxComponent);
exports.CheckboxComponent = CheckboxComponent;
//# sourceMappingURL=CheckboxComponent.js.map